import { PBAM_MENU_ITEMS } from "./pbamPrograms";
import { ROUTES } from "./routes";

/**
 * Главное меню как данные.
 *
 * Раньше каждый пункт был отдельной функцией `const newsPage = () => {...}`
 * (15 штук) плюс дважды продублированная разметка — для десктопа и для Drawer.
 * Теперь один массив питает оба представления.
 */
export const MAIN_NAV = [
  { id: "home", labelKey: "home", to: ROUTES.home, end: true },
  { id: "document", labelKey: "document", to: ROUTES.tajikistan },
  { id: "news", labelKey: "news", to: ROUTES.news },
  { id: "about", labelKey: "about", to: ROUTES.organization },
  { id: "project", labelKey: "project", to: ROUTES.ifas },
  {
    id: "public",
    labelKey: "public",
    to: ROUTES.publications,
    children: PBAM_MENU_ITEMS.map(({ slug, titleKey }) => ({
      id: slug,
      labelKey: titleKey,
      to: ROUTES.pbam(slug),
    })),
  },
  { id: "work", labelKey: "work", to: ROUTES.activity },
  { id: "reports", labelKey: "reports", to: ROUTES.reports },
  { id: "announcements", labelKey: "announcements", to: ROUTES.announcements },
];

/** Колонки подвала. */
export const FOOTER_COLUMNS = [
  {
    id: "about",
    titleKey: "aboutOrganization",
    links: [
      { labelKey: "chairman", to: ROUTES.organization },
      { labelKey: "mission", to: ROUTES.organization },
      { labelKey: "structure", to: ROUTES.organization },
    ],
  },
  {
    id: "activity",
    titleKey: "activity",
    links: [
      { labelKey: "PBAM1", to: ROUTES.pbam("pbam1") },
      { labelKey: "PBAM2", to: ROUTES.pbam("pbam2") },
      { labelKey: "PBAM3", to: ROUTES.pbam("pbam3") },
    ],
  },
  {
    id: "projects",
    titleKey: "projects",
    links: [
      { labelKey: "CAMP4ASB", to: ROUTES.program("CAMP4ASB") },
      { labelKey: "CAHP", to: ROUTES.program("CAHMP") },
    ],
  },
  {
    id: "documents",
    titleKey: "documents",
    links: [
      { labelKey: "agreements", to: ROUTES.reports },
      { labelKey: "regulations", to: ROUTES.reports },
      { labelKey: "decisions", to: ROUTES.reports },
      { labelKey: "protocols", to: ROUTES.reports },
      { labelKey: "declarations", to: ROUTES.reports },
    ],
  },
];

/** Контакты организации — используются в шапке и подвале. */
export const CONTACTS = {
  phone: "+992 (44) 625 52 52",
  phoneHref: "tel:+992446255252",
  youtube:
    "https://www.youtube.com/@%D0%A4%D0%B8%D0%BB%D0%B8%D0%B0%D0%BB%D0%B8%D0%9A%D1%83%D0%BC%D0%B8%D1%82%D0%B0%D0%B8%D0%98%D2%B7%D1%80%D0%BE%D0%B8%D1%8F%D0%B8%D0%A5%D0%91%D0%9D%D0%90%D0%B4%D0%B0%D1%80%D2%B6%D0%A2/videos",
};
